import { FEATURE_FLAG_KEYS } from '@alpha-core/feature-flags';
import { CustomCodeUtilService, Status } from '@alpha-core/platform-ui';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FeatureFlagsService } from '@neutrinos/ngx-feature-flags';

function waitForStatus(getter: () => Status, expected: Status.READY, timeout = 10): Promise<void> {
    return new Promise((resolve, reject) => {
        const start = Date.now();

        const checkStatus = () => {
            const status = getter();

            if (status === expected) {
                resolve();
            } else if (status === Status.ERROR) {
                reject(new Error('Unable to load PLUGINS'));
            } else if (Date.now() - start >= timeout * 1000) {
                reject(new Error('Timeout while waiting for PLUGINS'));
            } else {
                requestAnimationFrame(checkStatus);
            }
        };

        checkStatus();
    });
}

export const pluginsReadyResolver: ResolveFn<boolean> = async () => {
    const customCodeUtil = inject(CustomCodeUtilService);
    const featureFlagService = inject(FeatureFlagsService);

    // If PROJECT_PLUGINS feature flag is disabled, return true immediately
    if (!featureFlagService.isFeatureEnabled(FEATURE_FLAG_KEYS.PROJECT_PLUGINS)) {
        return true;
    }

    try {
        const TTL = window.environments['PLUGIN_LOAD_TTL'] || 20;
        await waitForStatus(() => window.isAlphaReady, Status.READY, TTL);
        await waitForStatus(() => window.isPluginReady, Status.READY, TTL);
        return true;
    } catch (err) {
        console.error('[Route Resolver] Alpha/AP not ready:', err);
        customCodeUtil.showConfirmReloadDialog('flex flex-column padding-16');
        return false;
    }
};
